import usePassport from "@/modules/common/hooks/passport";
import {
  PermissionLevel,
  PermissionsEnum,
  Permission,
} from "@/modules/common/types";
import { isLevelAllowed } from "@/modules/common/utils";
import { useLeadContext } from "@/modules/lead-page/context/lead-page.context";
import { Fragment, ReactNode } from "react";
import useAuth from "../../hooks/auth.hook";
interface PermissionGuardProps {
  children: ReactNode;
  permissions: Permission[];
  ifNotAllowed?: ReactNode;
}

const PermissionGuard = ({
  children,
  permissions,
  ifNotAllowed = <></>,
}: PermissionGuardProps) => {
  const { permissions: currentUserPermissions } = usePassport();
  const { isAssignedAgent } = useLeadContext();
  const { user } = useAuth();

  const userRoles = user?.["cognito:groups"];

  if (userRoles?.includes("crm-super-admin")) {
    return <Fragment>{children}</Fragment>;
  }

  const isUserAllowed = permissions?.some((permission) =>
    currentUserPermissions?.some(
      (userPermission) =>
        userPermission.name === permission.name &&
        isLevelAllowed({
          currentLevel: userPermission.level,
          requiredLevel: permission.level,
        })
    )
  );

  if (isAssignedAgent) {
    currentUserPermissions?.push({
      name: PermissionsEnum.ASSIGNED_AGENT,
      level: PermissionLevel.ALL,
    });
  }

  if (permissions?.some((permission) => permission.name === "*"))
    return <Fragment>{children}</Fragment>;

  if (isUserAllowed) return <Fragment>{children}</Fragment>;
  else return <Fragment>{ifNotAllowed}</Fragment>;
};

export default PermissionGuard;
